import { RecordOf } from '@opengov/compose-app/immutable';
import {REPORTING_ADMIN_CLAIM, REPORTING_ENTITLEMENT, REPORTING_MANAGER_PRIVILEGE, REPORTING_DASHBOARD_READ_ALL} from "./consts";
import { TClaims } from './types';
export const Claims = RecordOf<TClaims>({
  [REPORTING_ADMIN_CLAIM]: false,
  [REPORTING_ENTITLEMENT]: false,
  [REPORTING_MANAGER_PRIVILEGE]: false,
  [REPORTING_DASHBOARD_READ_ALL]: false,
});
